import { motion } from 'motion/react';

import styles from './NoizeValue.module.css';

export const NoizeValue = ({ noiseLevel }) => {
  const noiseLevelString = noiseLevel ? noiseLevel?.split('') : '';

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      exit={{ opacity: 0 }}
      className={styles.noiseLevel}
    >
      {noiseLevelString && (
        <div className={styles.stringValue}>
          {noiseLevelString?.map((l, i) => (
            <div key={i} className={`${l === ',' ? styles.comma : ''}`}>
              {l}
            </div>
          ))}
        </div>
      )}
    </motion.div>
  );
};
